import type { SVGProps } from "react";

export default function CircleMinusIcon({
  className,
  active,
  width = 24,
  height = 24,
}: {
  readonly active?: boolean;
} & Pick<SVGProps<"svg">, "className" | "width" | "height">) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
    >
      <path
        d="M12.0002 22.0005C17.5231 22.0005 22.0002 17.5233 22.0002 12.0005C22.0002 6.47764 17.5231 2.00049 12.0002 2.00049C6.4774 2.00049 2.00024 6.47764 2.00024 12.0005C2.00024 17.5233 6.4774 22.0005 12.0002 22.0005Z"
        fillOpacity="0.1"
        strokeWidth="1.25"
        {...(active
          ? { stroke: "#F5A800", fill: "#F5A800" }
          : { stroke: "currentColor" })}
      />
      <path
        d="M15 12H9"
        strokeWidth="1.25"
        strokeLinecap="round"
        {...(active ? { stroke: "#F5A800" } : { stroke: "currenColor" })}
      />
    </svg>
  );
}
